import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { Edit } from "@mui/icons-material";
import { Grid2, IconButton } from "@mui/material";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
import { RejectedBillet } from "../../models/RejectedBillet";

export const useTableData = ({
	onEditClick,
}: {
	onEditClick: (row: RejectedBillet) => void;
}) => {
	const columnDefs: (ColDef | ColGroupDef)[] = [
		{
			field: "Timestamp",
			headerName: "Timestamp",
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as RejectedBillet)?.Timestamp,
					"HH:mm:ss",
				) || "",
			flex: 1,
			sortable: true,
		},
		{
			field: "CampaignNumber",
			headerName: "Campaign",
			flex: 1,
			sortable: true,
		},
		{
			field: "HeatName",
			headerName: "Heat",
			flex: 1,
			sortable: true,
		},
		{
			field: "SectionName",
			headerName: "Section",
			flex: 1,
			sortable: true,
		},
		{
			field: "BilletCount",
			headerName: "Billet Count",
			flex: 1,
			sortable: true,
		},
		{
			field: "ColdLength",
			headerName: "Cold Length",
			flex: 1,
			sortable: true,
		},
		{
			field: "LbsPerFoot",
			headerName: "Lbs/Ft",
			flex: 1,
			sortable: true,
		},
		{
			field: "WeightCold",
			headerName: "Weight (lbs)",
			flex: 1,
			sortable: true,
			valueFormatter: (params) => {
				if (params.value != null) {
					return Number(params.value).toFixed(0);
				}
				return "";
			},
		},
		{
			field: "Comments",
			headerName: "Comments",
			flex: 2,
			sortable: true,
		},
		{
			field: "UpdatedAt",
			headerName: "Updated At",
			valueGetter: (params) =>
				dxtToLocalServerTime(
					(params.data as RejectedBillet)?.UpdatedAt,
					"MM/dd HH:mm:ss",
				) || "",
			flex: 1,
			sortable: true,
		},
		{
			field: "",
			headerName: "",
			flex: 1,
			maxWidth: 70,
			cellRenderer: (params: ICellRendererParams) => (
				<Grid2
					container
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						opacity: 0,
						transition: "opacity 0.1s ease-in-out",
					}}
					className={`buttons`}
				>
					<Grid2
						size={{ xs: 12, md: 12 }}
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<IconButton
							style={{ cursor: "pointer" }}
							title="Edit billet count"
							onClick={() => onEditClick(params.data as RejectedBillet)}
						>
							<Edit fontSize="inherit" color="primary" />
						</IconButton>
					</Grid2>
				</Grid2>
			),
		},
	];

	return { columnDefs };
};
